import { useEffect, useState } from 'react';

import { EntityStatus } from '../../../constants/entityStatus';
import { entityStatusService } from '../../../services/entityStatusService';
import {
  SolutionType,
  SOLUTION_TYPE,
} from '../../../../shared/constants/user-info/solutionType';

const solutionToServiceMap = {
  [SOLUTION_TYPE.NUTRITION]: entityStatusService.getNutritionStatusDetails,
  [SOLUTION_TYPE.SCAN_IQ]: entityStatusService.getScanIqStatusDetails,
  [SOLUTION_TYPE.CHALLENGE]: entityStatusService.getChallengeStatusDetails,
};

export const useEntityStatusInfo = (entityId: number, solution: SolutionType | null) => {
  const [status, setStatus] = useState<EntityStatus | null>(null);

  const getStatusDetails = async () => {
    if (!solution) {
      return;
    }

    const service = solutionToServiceMap[solution];
    const statusDetails = await service(entityId);

    setStatus(statusDetails.status);
  };

  useEffect(() => {
    getStatusDetails();
  }, [entityId, solution]);

  return { status };
};
